var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3458 3.79853C16.599 3.54536 16.8996 3.34454 17.2303 3.20753C17.5611 3.07052 17.9156 3 18.2737 3C18.6317 3 18.9862 3.07052 19.317 3.20753C19.6478 3.34454 19.9483 3.54536 20.2015 3.79853C20.4546 4.05169 20.6555 4.35224 20.7925 4.68301C20.9295 5.01379 21 5.36831 21 5.72634C21 6.08437 20.9295 6.43889 20.7925 6.76966C20.6555 7.10044 20.4546 7.40099 20.2015 7.65415L6.86803 21.0002H3L3 17.1322L16.3458 3.79853Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.fc3c1907222713d481ad084bea3bb26d.svg";
export { ForwardRef as ReactComponent };